import { atom } from 'jotai/index';
import { IPet } from '@/shared/interfaces';

export const petsAtom = atom<IPet[] | null>();
